import React from 'react';
import { motion } from 'framer-motion';
import { Anchor, Compass, Wind } from 'lucide-react';
export function About() {
  const features = [{
    icon: Anchor,
    title: 'Deep Roots',
    desc: 'Founded on three generations of maritime history.'
  }, {
    icon: Compass,
    title: 'Local Sourcing',
    desc: 'Daily catches from local fishermen we know by name.'
  }, {
    icon: Wind,
    title: 'Oceanfront',
    desc: 'Dining right on the edge of the Atlantic breakwater.'
  }];
  return <section id="about" className="py-24 bg-navy-900 relative overflow-hidden" data-id="element-12">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-navy-800/20 -skew-x-12 transform translate-x-1/4" data-id="element-13" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-14">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-15">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-16">
            <h2 className="font-heading font-bold text-4xl md:text-5xl text-white mb-6" data-id="element-17">
              Forged by the <span className="text-ocean-500" data-id="element-18">Sea</span>
            </h2>
            <div className="w-20 h-1 bg-gold-500 mb-8" data-id="element-19" />

            <p className="text-gray-300 text-lg leading-relaxed mb-6" data-id="element-20">
              The Dock Wall isn't just a restaurant; it's a tribute to the
              rugged beauty of the coast. Built directly into the historic
              harbor wall, we serve food that respects the power and purity of
              the ocean.
            </p>
            <p className="text-gray-300 text-lg leading-relaxed mb-10" data-id="element-21">
              Our philosophy is simple: let the ingredients speak. We pair the
              freshest daily catch with bold, confident flavors that mirror the
              dramatic seascape outside our windows.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6" data-id="element-22">
              {features.map((feature, idx) => <div key={idx} className="flex flex-col items-start p-4 border border-navy-800 bg-navy-800/30 rounded-sm" data-id="element-23">
                  <feature.icon className="w-8 h-8 text-gold-500 mb-3" data-id="element-24" />
                  <h3 className="font-heading font-bold text-white text-lg mb-1" data-id="element-25">
                    {feature.title}
                  </h3>
                  <p className="text-sm text-gray-400" data-id="element-26">{feature.desc}</p>
                </div>)}
            </div>
          </motion.div>

          {/* Image Grid */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-27">
            <div className="grid grid-cols-2 gap-4" data-id="element-28">
              <img src="https://images.unsplash.com/photo-1559339352-11d035aa65de?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Fresh seafood platter" className="rounded-sm object-cover h-64 w-full border-2 border-navy-800" data-id="element-29" />
              <img src="https://images.unsplash.com/photo-1519708227418-c8fd9a32b7a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Chef plating dish" className="rounded-sm object-cover h-64 w-full mt-12 border-2 border-navy-800" data-id="element-30" />
            </div>
            {/* Decorative border frame */}
            <div className="absolute inset-0 border-2 border-gold-500/30 -m-4 z-[-1]" data-id="element-31" />
          </motion.div>
        </div>
      </div>
    </section>;
}